<template>
  <div class="tianLing">
    <el-descriptions :title="tianLingData.fullName" :column="2" border>
      <el-descriptions-item
        label="在职时间"
        label-class-name="my-label"
        content-class-name="my-content"
      >
        {{ tianLingData.duration }}
      </el-descriptions-item>

      <el-descriptions-item label="所在岗位">
        {{ tianLingData.post }}
      </el-descriptions-item>

      <el-descriptions-item label="工作内容">
        <!--        {{ tianLingData.workAbout.substring(0, 342) }}-->
        {{ tianLingData.workAbout?.substring(0, 372) }}

        <el-popover
          placement="bottom"
          title=""
          width="200"
          trigger="click"
          :content="tianLingData.workAbout?.substring(368)"
        >
          <em class="tianLing-more" slot="reference"> >> 更多 </em>
        </el-popover>
      </el-descriptions-item>
    </el-descriptions>

    <div class="tianLing-title">项目经历</div>
    <div class="tianLing-project">
      <el-carousel
        indicator-position="outside"
        :interval="10000"
        :autoplay="false"
        arrow="always"
      >
        <el-carousel-item v-for="(chunk, index) in resProjectArr" :key="index">
          <div
            class="tianLing-project-public"
            v-for="item in chunk"
            :key="item.id"
          >
            <div :class="item.name.indexOf('App') === -1 ? 'img' : 'imgApp'">
              <el-image
                class="imgComp"
                :src="`/img/tianLingProject/${item.name}.png` | imgFormat"
                :preview-src-list="
                  [`/img/tianLingProject/${item.name}.png`] | imgFormat
                "
              >
                <div slot="placeholder" class="image-slot">
                  <img
                    style="width: 100%"
                    src="https://pic.imgdb.cn/item/65abdd55871b83018af558ee.gif"
                    alt=""
                  />
                </div>

                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>

            <div class="info" @click="showProjectDetailDialog(item.name, item)">
              <el-tooltip
                class="item"
                effect="dark"
                :content="`点击查看${item.name}详情`"
                placement="top"
              >
                <span class="info-name">{{ item.name }}</span>
                <span class="info-time">{{ item.time }}</span>
              </el-tooltip>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <detailDialog ref="detailDialog" />
  </div>
</template>

<script>
import makeNumArr from "@/utils/makeNumArr";
import {
  qiYun,
  qiYunEncryption,
  tianLing,
  tianLingEncryption,
} from "@/api/apifoxInterface";
import detailDialog from "@/views/homePage/projectBoxUnit/detailDialog.vue";

export default {
  name: "tianLing",
  components: { detailDialog },
  props: {},
  computed: {
    permission() {
      return this.$store.state.auth.permission;
    },
  },
  watch: {
    permission(newVal) {
      if (newVal.id === 3) {
        this.getTianLingData();
      }
    },
  },
  data() {
    return {
      tianLingData: {},
      resProjectArr: [],

      helpTianLingData: require("@/lib/json/apifox/tianLing.json"),
      helpTianLingEncryptionData: require("@/lib/json/apifox/tianLingE.json"),
    };
  },
  methods: {
    showProjectDetailDialog(title, data) {
      if (this.permission.id !== 3) {
        this.$message.warning("抱歉，您没有权限查看");
        return;
      }
      this.$refs.detailDialog.showDialog({
        title,
        data,
        type: "tianLingProject",
      });
    },

    async getTianLingData() {
      const getCompanyData = async () => {
        const res = await (this.permission.id === 3
          ? tianLing()
          : tianLingEncryption());
        if (res.data.code === 200) {
          return res.data.data;
        } else if (res.data.code === 504) {
          return this.permission.id === 3
            ? this.helpTianLingData.data
            : this.helpTianLingEncryptionData.data;
        }
        throw new Error(`Failed with code: ${res.data.code}`);
      };
      try {
        this.tianLingData = await getCompanyData();
        this.resProjectArr =
          this.tianLingData?.projectList &&
          this.tianLingData.projectList.length > 0
            ? makeNumArr(this.tianLingData.projectList, 6)
            : [];
      } catch (error) {
        console.error("An error occurred:", error.message);
      }
    },
  },
  created() {
    this.getTianLingData();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.tianLing {
  position: relative;

  &-more {
    color: #4c64fe;
    cursor: pointer;
  }

  &-title {
    color: #303133;
    font-size: 16px;
    font-weight: 700;
    margin: 20px 0 0;
    text-align: center;
  }

  &-project {
    width: 100%;
    height: calc(100vh - 300px);
    margin-top: 10px;

    &-public {
      width: calc(33% - 40px);
      height: calc(50% - 2px - 40px);
      float: left;
      cursor: pointer;
      padding: 20px;

      .img {
        width: 100%;
        height: calc(100% - 48px);
        text-align: center;

        .imgComp {
          width: 320px !important;
          height: 100% !important;
          object-fit: contain;
        }
      }

      .imgApp {
        width: 100%;
        height: calc(100% - 48px);
        text-align: center;

        .imgComp {
          width: 90px !important;
          height: 100% !important;
          object-fit: contain;
        }
      }

      .info {
        height: 48px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        text-align: center;

        &-name {
          font-size: 14px;
          font-weight: 600;
          margin: 16px 0 8px 0;
        }

        &-time {
          color: #333;
          font-size: 14px;
        }

        span {
          width: 100%;
        }
      }

      .info:hover {
        color: #587fdc !important;
      }
    }

    &-public:hover {
      transform: scale(1.2);
    }
  }
}

::v-deep .my-label {
  width: 150px !important;
}

::v-deep .my-content {
}

.el-carousel--horizontal {
  width: 100% !important;
  height: calc(100vh - 300px) !important;
}

::v-deep .el-carousel__container {
  height: calc(100vh - 330px) !important;
}

::v-deep .el-carousel__item {
}
</style>
